export default {
  100000: {
    //API获取config配置
    code: '100000',
    needRepeat: 0, //0，不重试，1实时重试，2延迟重试
    needLoading: false,
    alert: true,
    isRequest: false,
  },
  100001: {
    //获取环境配置
    code: '100001',
    needRepeat: 0,
    needLoading: false,
    alert: true,
    isRequest: false,
  },
  100105: {
    //API学生登陆
    code: '100105',
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false,
  },
  100104: {
    //API手机号验证
    code: '100104',
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false,
  },
  100106: {
    //获取验证码
    code: '100106',
    needRepeat: 0,
    needLoading: true,
    alert: false,
    isRequest: false,
  },
  100107: {
    //重置密码
    code: '100107',
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false,
  },
  100108: {
    //效验验证码
    code: '100108',
    needRepeat: 0,
    needLoading: true,
    alert: false,
    isRequest: false,
  },
  100109: {
    //验证码登录
    code: '100109',
    needRepeat: 0,
    needLoading: true,
    alert: false,
    isRequest: false,
  },
  100111: {
    //重置密码
    code: '100111',
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false,
  },
  400005: {
    //API获取快速问答列表
    code: '400005',
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  400006: {
    //API获取标准快速问答
    code: '400006',
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  400025: {
    //API获取体验课标准快速问答
    code: '400025',
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  400028: {
    //回放页获取标准快速问答
    code: '400028',
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  300110: {
    //HTTP补发接口
    code: '300110',
    needRepeat: 2,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  300118: {
    //API获取资源文件get-zip
    code: '300118',
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  100115: {
    //API修改头像情况
    code: '100115',
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false,
  },
  300127: {
    //API获取默认头像列表
    code: '300127',
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false,
  },
  300163: {
    //API获取徽章
    code: '300163',
    needRepeat: 0,
    needLoading: true,
    alert: false,
    isRequest: false,
  },
  300119: {
    //API进课消息
    code: '300119',
    needRepeat: 0,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  300129: {
    //API退课
    code: '300129',
    needRepeat: 0,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  400035: {
    //API退课-录播课
    code: '400035',
    needRepeat: 0,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  300117: {
    //API轮训获取数据
    code: '300117',
    needRepeat: 0,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  300130: {
    //请求课件题json数据
    code: '300130',
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  300209: {
    //客户评价数据补发
    code: '300209',
    needRepeat: 2,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  300136: {
    //获取直播课中徽章同学列表
    code: '300136',
    needRepeat: 2,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  300183: {
    //获取拉流地址接口
    code: '300183',
    needRepeat: 0,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  300142: {
    //获取发题记录
    code: '300142',
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  400034: {
    //获取发题记录-录播课
    code: '400034',
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  300135: {
    //门店虚拟体验课答题API
    code: '300135',
    needRepeat: 2,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  400008: {
    //API检查版本更新
    code: '400008',
    needRepeat: 0,
    needLoading: false,
    alert: false,
    isRequest: false,
  },

  300143: {
    //课前测答案上报
    code: '300143',
    needRepeat: 2,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  300171: {
    //答题排行榜
    code: '300171',
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  300146: {
    //首页徽章上报
    code: '300146',
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  300173: {
    //学生端领取徽章排行榜1
    code: '300173',
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  300185: {
    //课时和课程状态查询
    code: '300185',
    needRepeat: 0,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  300186: {
    //设置弹幕颜色
    code: '300186',
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  300200: {
    //首页base-data
    code: '300200',
    needRepeat: 0,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  300154: {
    //获取长连接地址
    code: '300154',
    needRepeat: 0,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  400012: {
    //获取服务器时间
    code: '400012',
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  300199: {
    //获取消息列表
    code: '300199',
    needRepeat: 0,
    needLoading: true,
    alert: false,
    isRequest: false,
  },
  300159: {
    //获取单条消息详情
    code: '300159',
    needRepeat: 0,
    needLoading: true,
    alert: false,
    isRequest: false,
  },
  300160: {
    //删除单条消息
    code: '300160',
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false,
  },
  300161: {
    //问题反馈
    code: '300161',
    needRepeat: 0,
    needLoading: true,
    alert: false,
    isRequest: false,
  },
  300164: {
    //获取问题反馈标签
    code: '300164',
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false,
  },
  300165: {
    // 获取ossToken
    code: '300165',
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  300167: {
    // oss上传语音成功
    code: '300167',
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  300170: {
    // 直接跳转直播页面
    code: '300170',
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false,
  },
  300174: {
    //语音连麦上报异常
    code: '300174',
    needRepeat: 0,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  300231: {
    //请求课时列表
    code: '300231',
    needRepeat: 0,
    needLoading: true,
    alert: false,
    isRequest: false,
  },
  300230: {
    //获取体验课列表
    code: '300230',
    needRepeat: 0,
    needLoading: true,
    alert: false,
    isRequest: false,
  },
  300176: {
    //获取礼物列表
    code: '300176',
    needRepeat: 2,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  900002: {
    //直播回放持续观看时间上报
    code: '900002',
    needRepeat: 2,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  300178: {
    //获取表扬信息
    code: '300178',
    needRepeat: 2,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  300179: {
    //API获取学生报的班
    code: '300179',
    needRepeat: 0,
    needLoading: true,
    alert: false,
    isRequest: false,
  },
  300177: {
    //礼物补发接口
    code: '300177',
    needRepeat: 2,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  300189: {
    //pk补发接口
    code: '300189',
    needRepeat: 2,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  300201: {
    //回放页获取发题记录
    code: '300201',
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false,
  },
  300202: {
    //课后练习首页
    code: '300202',
    needRepeat: 0,
    needLoading: true,
    alert: false,
    isRequest: false,
  },
  400030: {
    //课后练习重新做题
    code: '400030',
    needRepeat: 0,
    needLoading: true,
    alert: false,
    isRequest: false,
  },
  300203: {
    //课后练习保存每道题答题信息
    code: '300203',
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false,
  },
  300204: {
    //课后练习答题卡提交
    code: '300204',
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false,
  },
  300205: {
    //课后练习订正
    code: '300205',
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false,
  },
  300206: {
    //快速问答选择题样式
    code: '300206',
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false,
  },
  400026: {
    //头饰列表
    code: '400026',
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false,
  },
  400027: {
    //修改头饰
    code: '400027',
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false,
  },
};



// WEBPACK FOOTER //
// ./src/js/axiosConfig.js